const ONE_MINUTE_MS = 60000;
export default class Const {
	static OAUTH_REFRESH_TOKEN_DURATION_MS = 30 * ONE_MINUTE_MS;
	static OAUTH_SESSION_DURATION_MS = 8 * 60 * ONE_MINUTE_MS;
}
